<template>
  <div class="content">
    <div class="row">
      <div class="col-md-3">
        <div class="quad py-5 px-3 text-center">
          <h4>Passo 1</h4>
          <div class="pt-6 pb-2">
            <p style="height: 120px">Valide o seu acesso ao Bling.</p>
            <button
              class="btn btn-primary"
              type="button"
              @click="validarAplicativo()"
              v-if="!state.continuar"
            >
              Validar Acesso
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="quad py-5 px-3 text-center">
          <h4>Passo 2</h4>
          <div class="pt-6 pb-2">
            <p style="height: 120px">
              Agora que você já validou seu acesso, o geraremos os tokens do
              Bling para você.
            </p>
            <button
              class="btn btn-primary"
              type="button"
              @click="fazerAutenticacao()"
              v-if="!state.continuar"
            >
              Gerar Tokens
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="quad py-5 px-3 text-center">
          <h4>Passo 3</h4>
          <div class="pt-6 pb-2">
            <p style="height: 120px">
              Concluído. Agora você pode usar suas configurações.
            </p>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group text-start">
                  <label>Empresa</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="state.empresa"
                    readonly
                  />
                </div>
              </div>
            </div>

            <div class="form-group text-start">
              <label>Access Token</label>
              <input
                type="text"
                class="form-control"
                v-model="state.access_token"
                readonly
              />
            </div>
            <div class="form-group text-start">
              <label>Refresh Token</label>
              <input
                type="text"
                class="form-control"
                v-model="state.refresh_token"
                readonly
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="quad py-5 px-3 text-center">
          <h4>Passo 4</h4>
          <div class="pt-6 pb-2">
            <p style="height: 120px">
              <!-- v-if="!state.data_importacao_pedidos" -->
              Ops, você ainda não fez a primeira importação de produtos, vamos
              fazer?
            </p>
            <!--
              <p style="height: 120px">
                v-else
                Última importação completa feita em
                {{ state.data_importacao_pedidos }}
              </p>-->
            <div class="loading" v-if="state.loading_produtos">
              <p>
                <span>Importando Produtos...</span> Isso poderá demorar vários
                minutos
              </p>
              <img src="/images/loading.gif" />
            </div>
            <button
              class="btn btn-primary"
              type="button"
              :disabled="state.loading_produtos"
              @click="importarProdutos()"
              v-if="!state.continuar"
            >
              Importar Produtos
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="quad py-5 px-3 text-center">
          <h4>Passo 5</h4>
          <div class="pt-6 pb-2">
            <p style="height: 120px">
              <!-- v-if="!state.data_importacao_pedidos" -->
              Ops, você ainda não fez a primeira importação de pedidos, vamos
              fazer?
            </p>
            <!--
              <p style="height: 120px">
                v-else
                Última importação completa feita em
                {{ state.data_importacao_pedidos }}
              </p>-->
            <div class="loading" v-if="state.loading_produtos">
              <p>
                <span>Importando Produtos...</span> Isso poderá demorar vários
                minutos
              </p>
              <img src="/images/loading.gif" />
            </div>
            <button
              class="btn btn-primary"
              type="button"
              :disabled="state.loading_produtos"
              @click="importarPedidos()"
              v-if="!state.continuar"
            >
              Importar Pedidos
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="quad px-3 py-2 d-none">
      <div class="row mt-4">
        <div class="col-md-6">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home"
                type="button"
                role="tab"
                aria-controls="home"
                aria-selected="true"
              >
                Autorização do Bling
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#profile"
                type="button"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
              >
                Dados para Autenticação
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="token-tab"
                data-bs-toggle="tab"
                data-bs-target="#token"
                type="button"
                role="tab"
                aria-controls="token"
                aria-selected="false"
              >
                Tokens
              </button>
            </li>
          </ul>
          <div class="tab-content px-3 py-2" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div class="form-group">
                <label>Client ID </label> (Campo dentro da aplicação do Mercado
                Livre)
                <input
                  type="text"
                  class="form-control"
                  readonly
                  v-model="state.application_id"
                />
              </div>
              <button
                class="btn btn-primary"
                type="button"
                @click="validarAplicativo()"
                v-if="!state.continuar"
              >
                Validar Acesso
              </button>

              <button
                class="btn btn-success"
                type="button"
                @click="continuarParaAutenticacao()"
                v-else
              >
                Continuar
              </button>
            </div>
            <div
              class="tab-pane fade"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div class="form-group d-flex">
                <div style="width: 100%">
                  <label>Code</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="state.code"
                  />
                </div>
                <button class="btn btn-primary" @click="obterCode()">
                  Obter
                </button>
              </div>

              <div class="form-group">
                <label>Cliente Secret</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="state.client_secret"
                />
              </div>

              <button
                class="btn btn-primary"
                type="button"
                @click="fazerAutenticacao()"
              >
                Salvar e Gerar Token
              </button>
            </div>
            <div
              class="tab-pane fade"
              id="token"
              role="tabpanel"
              aria-labelledby="token-tab"
            >
              <div class="form-group">
                <label>Access Token</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="state.access_token"
                />
              </div>
              <div class="form-group">
                <label>Refresh Token</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="state.refresh_token"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row"></div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useRouter } from "vue-router";
import { useStorage } from "vue3-storage";

export default {
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const router = useRouter();
    // var empresa_id = storage.getStorageSync("empresa_id");

    var usuario = storage.getStorageSync("usuario");
    onMounted(() => {
      //     fetchConfiguracaoToken();
      fetchConfiguracaoBling();
    });

    const state = reactive({});

    async function obterCode() {
      try {
        //  const { data } = await services.cliente.getConfiguracao({
        const { data } = await services.clientes.getCode({
          token,
        });
        state.code = data;
      } catch (error) {
        console.log(error);
      }
    }

    async function fazerAutenticacao() {
      try {
        //  const { data } = await services.cliente.getConfiguracao({
        await services.configuracao
          .fazerAutenticacao({
            token,
          })
          .then((response) => {
            state.empresa = response.data.usuario.nome;
            state.access_token = response.data.configuracao.access_token;
            state.refresh_token = response.data.configuracao.refresh_token;
          });
      } catch (error) {
        console.log(error);
      }
    }

    async function fetchConfiguracaoBling() {
      try {
        const { data } = await services.configuracao.get({
          token,
        });
        state.url = data.url;
        state.client_id = data.client_id;
        state.client_secret = data.client_secret;
      } catch (error) {
        alert("Erro ao obter dados da configuração do Bling!");
      }
    }

    async function fetchConfiguracaoToken() {
      try {
        const { data } = await services.configuracao.get({
          token,
        });
        state.redirect_uri = data.redirect_uri;
        state.client_secret = data.client_secret;
        state.application_id = data.application_id;
      } catch (error) {
        alert("Erro ao obter dados da configuração do Sistema!");
      }
    }
    async function saveMercadoLivre() {
      try {
        const { data } = await services.usuarioMercadoLivre.save({
          token,
          usuario,
        });
        state.configuracoes = data;
      } catch (error) {
        alert("Erro ao salvar dados da configuração do Bling!");
      }
    }

    async function validarAplicativo() {
      const url =
        "https://www.bling.com.br/Api/v3/oauth/authorize?response_type=code&client_id=" +
        state.client_id +
        "&redirect_uri=" +
        state.url +
        "&scope=pedidos%20produtos%20lojas%20categorias&state=1";

      // console.log(url);
      window.open(url, "_blank");
    }

    async function continuarParaAutenticacao() {
      await services.usuarioMercadoLivre.saveClientID({
        token,
        client_id: state.client_id,
      });
    }

    async function importarProdutos() {
      let inicio = 1;
      let fim = 1000;
      let acabou = false;
      while (!acabou) {
        const response = await services.produtos.importarProdutos({
          token,
          pagina: inicio,
        });
        console.log(response.data.ultima);
        if (response.data.ultima) {
          acabou = true;
          break;
        }
        inicio++;
      }
      /*
      const { data } = await services.produtos
        .atualizarProdutos({
          token,
        })
        .then(() => {
          state.configuracoes = data;
        });*/
    }

    async function importarPedidos() {
      const { data } = await services.vendas
        .atualizarPedidos({
          token,
        })
        .then(() => {
          state.configuracoes = data;
        });
    }

    async function saveDadosAndToken() {
      const { data } = await services.usuarioMercadoLivre
        .save({
          token,
          usuario: state.usuario,
        })
        .then(() => {
          state.configuracoes = data;
        });
    }

    return {
      saveMercadoLivre,
      validarAplicativo,
      continuarParaAutenticacao,
      saveDadosAndToken,
      obterCode,
      fazerAutenticacao,
      importarPedidos,
      importarProdutos,
      state,
    };
  },
};
</script>
<style scoped>
.content {
  padding: 4rem;
}

.card {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  height: 140px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  border: solid 1px #0000000d;
}

.card #icon_card {
  width: 60px;
  height: 60px;
  margin-right: 15px;
  object-fit: contain;
}

.info p {
  margin-bottom: 0;
  color: #787878;
  font-size: 18px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}

.info h3 {
  margin-bottom: 0;
  color: #001942;
  font-size: 26px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.coluna {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: solid 1px #0000000d;
}

.coluna h2 {
  font-weight: 600;
  color: #001942;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  padding: 10px;
}

.coluna-itens {
  padding: 20px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  margin-bottom: 2rem;
}

.info2 {
  margin-left: 15px;
}

.info2 p {
  margin-bottom: 0;
  color: #787878;
  font-size: 18px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}

.info2 h3 {
  margin-bottom: 0;
  color: #001942;
  font-size: 26px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.quad {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: solid 1px #0000000d;
}

.quad h2 {
  font-weight: 600;
  color: #001942;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  padding: 10px;
  margin-bottom: 0;
}

.quad_inativo {
  background: #9d9d9d;
}

.search {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 1rem;
}

.search input {
  width: 100%;
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 0 45px 45px 0;
  background: #f4f7fe;
}

.search input::placeholder {
  color: #9d9d9d;
}

.search .btn_search {
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 45px 0 0 45px;
  background: #f4f7fe;
  color: #9d9d9d;
}

.table {
  border-radius: 6px;
  font-family: "Poppins", sans-serif;
}

label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}

input {
  border: solid 1px #000;
}

input:focus {
  border: solid 1px #0a516d;
}

h5 {
  color: #000;
}

tr {
  text-align: center;
}

th {
  color: #fff;
  border-bottom: solid 2px #000 !important;
}

td {
  border-bottom: solid 1px #000 !important;
  color: #000;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

#btn_new_user {
  color: #000;
  font-weight: 600;
  padding: 5px;
  border: solid 2px #000;
  border-radius: 5px;
  background-color: rgb(152, 152, 152);
  transition: 0.2s;
}

#btn_new_user:hover {
  background-color: rgb(210, 209, 209);
}

.table-hover > tbody > tr:hover > * {
  color: rgb(0, 0, 0);
  background-color: rgb(225, 225, 225);
}
</style>
